import { MdCreate, MdImage, MdVideocam } from "react-icons/md";
// import { name } from "../../../pages/earnings/data";
// import TextStatus from "./Text.status";
// import ImageStatus from "./Image.status";
// import VideoStatus from "./Video.status";

// interface IStatus {
//   id: number;
//   label: string;
//   icon: React.FC<any>;
//   name: string;
// }

export const statusList = [
  {
    id: 1,
    label: "Image",
    icon: MdImage,
    name: "image",
  },
  {
    id: 2,
    label: "Video",
    icon: MdVideocam,
    name: "video",
  },
  {
    id: 3,
    label: "Text",
    icon: MdCreate,
    name: "text",
  },
];
